var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvanialogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "Advania Sverige AB",
    title: "Advania Sverige AB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M174.359 26.339C172.689 26.339 171.338 27.6908 171.338 29.3606C171.338 31.0288 172.689 32.3826 174.359 32.3826C176.029 32.3826 177.38 31.0288 177.38 29.3606C177.38 27.6908 176.029 26.339 174.359 26.339ZM90.1453 38.1135C92.6115 38.1135 93.9287 39.6094 94.1438 40.1928V47.6306C93.6939 48.373 92.448 50.056 90.3345 50.056C87.881 50.056 86.6285 48.5967 86.3183 47.9342C85.8709 46.9718 85.7654 45.4074 85.7654 44.1138C85.7654 42.715 85.9269 41.2793 86.4909 40.3498C87.326 38.9745 88.5892 38.1135 90.1453 38.1135ZM100.923 50.9447C100.631 50.9447 100.407 50.9364 100.243 50.9233C100.086 50.9126 99.9632 50.8846 99.8858 50.8265C99.8062 50.7618 99.763 50.6587 99.7437 50.5166C99.7309 50.37 99.7288 50.1677 99.7288 49.9053V26.5026H92.3232V28.4097H92.9428C93.2419 28.4097 93.466 28.4159 93.623 28.429C93.7824 28.4439 93.9028 28.4785 93.9802 28.5342C94.0663 28.5988 94.1095 28.696 94.1203 28.8423C94.1331 28.982 94.1438 29.1908 94.1438 29.4533V36.564C93.7392 36.1314 93.1237 35.7527 92.2886 35.4256C91.4493 35.1026 90.3818 34.9456 89.0778 34.9456C87.9069 34.9456 86.7769 35.1244 85.6859 35.4795C84.5925 35.8454 83.6218 36.3983 82.776 37.1581C81.9239 37.9157 81.2437 38.8798 80.7402 40.0527C80.2323 41.2278 79.9826 42.6442 79.9826 44.2947C79.9826 46.0724 80.2648 47.5293 80.8156 48.6784C81.3772 49.8299 82.0875 50.7466 82.9547 51.4313C83.8134 52.1177 84.7775 52.5935 85.8494 52.8667C86.9103 53.1444 87.9457 53.2841 88.9526 53.2841C89.9167 53.2841 90.7456 53.1724 91.4493 52.9573C92.1509 52.7463 92.7471 52.4984 93.2271 52.2211C93.6403 51.98 93.9757 51.7411 94.234 51.5108V52.8432H94.8994V52.8494H101.543V50.9447H100.923ZM192.34 49.8299C192.136 49.9959 191.899 50.1677 191.622 50.3337C191.339 50.5059 191.017 50.637 190.644 50.7466C190.272 50.8586 189.859 50.9084 189.407 50.9084C188.637 50.9084 187.969 50.7016 187.41 50.2777C186.852 49.8665 186.575 49.1241 186.575 48.0653C186.575 47.2754 186.74 46.6578 187.078 46.1993C187.41 45.7474 187.853 45.3988 188.43 45.1578C188.873 44.9703 189.36 44.9489 189.904 44.9295H192.79V49.4038C192.685 49.5242 192.532 49.6622 192.34 49.8299ZM199.376 50.9447C199.087 50.9447 198.861 50.9364 198.704 50.9233C198.539 50.9126 198.416 50.8846 198.338 50.8265C198.259 50.7618 198.218 50.6587 198.201 50.5166C198.185 50.37 198.181 50.1677 198.181 49.9053V40.3799C198.181 39.2972 197.992 38.4126 197.598 37.7134C197.215 37.0163 196.685 36.4651 196.001 36.0584C195.33 35.6559 194.512 35.3696 193.552 35.1953C192.596 35.0338 191.561 34.9456 190.444 34.9456C189.484 34.9456 188.542 35.0252 187.608 35.1801C186.678 35.3374 185.839 35.5096 185.094 35.7033C184.353 35.8928 183.73 36.0819 183.22 36.2801C182.72 36.4651 182.415 36.6006 182.307 36.6781V41.0234H185.776V39.5448C185.776 39.2844 185.804 39.0347 185.856 38.7937C185.908 38.5572 186.041 38.3355 186.256 38.1481C186.657 37.7867 187.186 37.537 187.848 37.3904C188.514 37.2442 189.11 37.1753 189.641 37.1753C190.844 37.1753 191.667 37.3904 192.114 37.8251C192.573 38.2577 192.794 39.1187 192.794 40.4165V42.4975H190.044C188.873 42.4975 187.754 42.5771 186.673 42.7299C185.598 42.8873 184.638 43.1777 183.798 43.6124C182.963 44.0429 182.296 44.6284 181.806 45.3729C181.315 46.1174 181.069 47.0666 181.069 48.2095C181.069 49.1715 181.259 49.9699 181.65 50.6176C182.029 51.2677 182.552 51.7905 183.202 52.1844C183.854 52.5807 184.599 52.8625 185.438 53.0323C186.278 53.2004 187.132 53.2841 188.01 53.2841C188.862 53.2841 189.611 53.2004 190.261 53.0323C190.914 52.8625 191.465 52.671 191.919 52.4621C192.278 52.2833 192.568 52.1177 192.79 51.95V52.8452H193.384V52.8494H200V50.9447H199.376ZM135.452 49.8299C135.25 49.9959 135.011 50.1677 134.734 50.3337C134.454 50.5059 134.131 50.637 133.759 50.7466C133.384 50.8586 132.973 50.9084 132.519 50.9084C131.748 50.9084 131.083 50.7016 130.524 50.2777C129.967 49.8665 129.686 49.1241 129.686 48.0653C129.686 47.2754 129.852 46.6578 130.192 46.1993C130.524 45.7474 130.967 45.3988 131.544 45.1578C131.987 44.9703 132.474 44.9489 133.018 44.9295H135.904V49.4038C135.799 49.5242 135.646 49.6622 135.452 49.8299ZM142.49 50.9447C142.202 50.9447 141.975 50.9364 141.816 50.9233C141.651 50.9126 141.53 50.8846 141.453 50.8265C141.373 50.7618 141.332 50.6587 141.315 50.5166C141.298 50.37 141.295 50.1677 141.295 49.9053V40.3799C141.295 39.2972 141.106 38.4126 140.712 37.7134C140.329 37.0163 139.8 36.4651 139.115 36.0584C138.444 35.6559 137.626 35.3696 136.666 35.1953C135.709 35.0338 134.673 34.9456 133.558 34.9456C132.598 34.9456 131.656 35.0252 130.722 35.1801C129.79 35.3374 128.953 35.5096 128.208 35.7033C127.468 35.8928 126.844 36.0819 126.334 36.2801C125.834 36.4651 125.529 36.6006 125.419 36.6781V41.0234H128.89V39.5448C128.89 39.2844 128.918 39.0347 128.968 38.7937C129.022 38.5572 129.155 38.3355 129.37 38.1481C129.769 37.7867 130.3 37.537 130.963 37.3904C131.628 37.2442 132.224 37.1753 132.753 37.1753C133.956 37.1753 134.781 37.3904 135.229 37.8251C135.687 38.2577 135.909 39.1187 135.909 40.4165V42.4975H133.158C131.987 42.4975 130.868 42.5771 129.786 42.7299C128.712 42.8873 127.752 43.1777 126.913 43.6124C126.077 44.0429 125.408 44.6284 124.92 45.3729C124.429 46.1174 124.184 47.0666 124.184 48.2095C124.184 49.1715 124.373 49.9699 124.765 50.6176C125.143 51.2677 125.666 51.7905 126.316 52.1844C126.968 52.5807 127.713 52.8625 128.553 53.0323C129.392 53.2004 130.246 53.2841 131.124 53.2841C131.977 53.2841 132.726 53.2004 133.375 53.0323C134.028 52.8625 134.578 52.671 135.032 52.4621C135.39 52.2833 135.683 52.1177 135.904 51.95V52.8452H136.498V52.8494H143.114V50.9447H142.49ZM71.1758 49.8299C70.9735 49.9959 70.7345 50.1677 70.4572 50.3337C70.1775 50.5059 69.8545 50.637 69.4824 50.7466C69.1079 50.8586 68.6968 50.9084 68.2427 50.9084C67.4723 50.9084 66.807 50.7016 66.2475 50.2777C65.688 49.8665 65.4124 49.1241 65.4124 48.0653C65.4124 47.2754 65.5783 46.6578 65.9162 46.1993C66.2475 45.7474 66.6887 45.3988 67.2676 45.1578C67.7112 44.9703 68.1974 44.9489 68.7417 44.9295H71.6278V49.4038C71.5226 49.5242 71.3677 49.6622 71.1758 49.8299ZM78.2135 50.9447C77.9251 50.9447 77.6969 50.9364 77.5399 50.9233C77.3742 50.9126 77.2539 50.8846 77.1761 50.8265C77.0945 50.7618 77.0558 50.6587 77.0385 50.5166C77.0212 50.37 77.0191 50.1677 77.0191 49.9053V40.3799C77.0191 39.2972 76.8275 38.4126 76.4361 37.7134C76.0526 37.0163 75.5232 36.4651 74.8388 36.0584C74.1676 35.6559 73.3498 35.3696 72.3899 35.1953C71.432 35.0338 70.3991 34.9456 69.2822 34.9456C68.3223 34.9456 67.3796 35.0252 66.4456 35.1801C65.5157 35.3374 64.6765 35.5096 63.9316 35.7033C63.1892 35.8928 62.565 36.0819 62.0571 36.2801C61.5581 36.4651 61.2503 36.6006 61.1448 36.6781V41.0234H64.6139V39.5448C64.6139 39.2844 64.6419 39.0347 64.6917 38.7937C64.7453 38.5572 64.8764 38.3355 65.0939 38.1481C65.4943 37.7867 66.0216 37.537 66.6866 37.3904C67.3516 37.2442 67.9478 37.1753 68.4772 37.1753C69.6802 37.1753 70.5046 37.3904 70.9521 37.8251C71.4085 38.2577 71.6322 39.1187 71.6322 40.4165V42.4975H68.8818C67.7112 42.4975 66.5898 42.5771 65.5116 42.7299C64.4355 42.8873 63.4755 43.1777 62.6363 43.6124C61.8012 44.0429 61.1317 44.6284 60.6431 45.3729C60.1527 46.1174 59.9072 47.0666 59.9072 48.2095C59.9072 49.1715 60.0967 49.9699 60.4882 50.6176C60.8672 51.2677 61.39 51.7905 62.0401 52.1844C62.6919 52.5807 63.4368 52.8625 64.274 53.0323C65.1153 53.2004 65.9698 53.2841 66.8481 53.2841C67.6981 53.2841 68.4471 53.2004 69.0993 53.0323C69.7514 52.8625 70.3023 52.671 70.7539 52.4621C71.1135 52.2833 71.4044 52.1177 71.6278 51.95V52.8452H72.2218V52.8494H78.8377V50.9447H78.2135ZM177.144 49.9053C177.144 50.1677 177.15 50.37 177.165 50.5166C177.178 50.6587 177.224 50.7618 177.303 50.8265C177.385 50.8846 177.503 50.9126 177.663 50.9233C177.82 50.9364 178.048 50.9447 178.338 50.9447H178.962V52.8494H169.742V50.9447H170.362C170.653 50.9447 170.881 50.9364 171.041 50.9233C171.2 50.9126 171.314 50.8846 171.402 50.8265C171.481 50.7618 171.529 50.6587 171.54 50.5166C171.555 50.37 171.561 50.1677 171.561 49.9053V38.2577C171.561 37.9866 171.555 37.7867 171.54 37.6401C171.529 37.5004 171.481 37.397 171.402 37.3348C171.314 37.2787 171.2 37.2442 171.041 37.2334C170.881 37.2203 170.653 37.2141 170.362 37.2141H169.742V35.3053H177.144V49.9053ZM145.761 35.3053H152.691L152.687 36.99C152.846 36.8524 153.096 36.6674 153.444 36.4371C153.789 36.2112 154.221 35.9851 154.74 35.7527C155.257 35.5269 155.872 35.3374 156.573 35.1801C157.275 35.0252 158.069 34.9456 158.948 34.9456C161.072 34.9456 162.656 35.4429 163.693 36.4371C164.73 37.4336 165.251 38.867 165.251 40.7371V49.9053C165.251 50.1677 165.255 50.37 165.273 50.5166C165.283 50.6587 165.326 50.7618 165.408 50.8265C165.492 50.8846 165.61 50.9126 165.772 50.9233C165.922 50.9364 166.151 50.9447 166.443 50.9447H167.068V52.8494H158.257V50.9447H158.467C158.76 50.9447 158.988 50.9364 159.147 50.9233C159.307 50.9126 159.425 50.8846 159.507 50.8265C159.587 50.7618 159.63 50.6587 159.647 50.5166C159.66 50.37 159.668 50.1677 159.668 49.9053V42.0649C159.668 41.3484 159.651 40.7136 159.627 40.1582C159.599 39.607 159.507 39.1509 159.346 38.7764C159.186 38.404 158.948 38.1221 158.629 37.9351C158.312 37.7393 157.856 37.6401 157.271 37.6401C156.797 37.6401 156.331 37.7003 155.891 37.8251C155.459 37.9458 155.067 38.09 154.714 38.2684C154.374 38.4513 154.064 38.6429 153.801 38.8497C153.535 39.0499 153.322 39.2218 153.162 39.3705V49.9053C153.162 50.1677 153.169 50.37 153.184 50.5166C153.197 50.6587 153.238 50.7618 153.322 50.8265C153.401 50.8846 153.524 50.9126 153.686 50.9233C153.838 50.9364 154.064 50.9447 154.361 50.9447H154.566V52.8494H145.761V50.9447H146.385C146.674 50.9447 146.9 50.9364 147.061 50.9233C147.22 50.9126 147.336 50.8846 147.42 50.8265C147.5 50.7618 147.55 50.6587 147.556 50.5166C147.575 50.37 147.58 50.1677 147.58 49.9053V38.2577C147.58 37.9866 147.575 37.7867 147.556 37.6401C147.55 37.5004 147.5 37.397 147.42 37.3348C147.336 37.2787 147.22 37.2442 147.061 37.2334C146.9 37.2203 146.674 37.2141 146.385 37.2141H145.761V35.3053ZM115.571 52.8494H110.311L103.609 38.2577C103.476 37.9866 103.363 37.7867 103.271 37.6401C103.178 37.5004 103.071 37.397 102.955 37.3348C102.827 37.2787 102.684 37.2442 102.511 37.2334C102.339 37.2203 102.115 37.2141 101.853 37.2141H101.827V35.3053H110.812V37.2141H110.388C110.044 37.2141 109.769 37.2248 109.568 37.2442C109.37 37.2722 109.248 37.3472 109.213 37.481C109.179 37.6142 109.2 37.8251 109.291 38.1093C109.385 38.3977 109.551 38.8044 109.79 39.3338L114.062 49.2596L118.089 39.478C118.326 38.8991 118.502 38.4645 118.607 38.1654C118.713 37.8662 118.749 37.6401 118.709 37.5004C118.665 37.3517 118.554 37.2722 118.368 37.2442C118.181 37.2248 117.902 37.2141 117.534 37.2141H117.31V35.3053H123.616V37.2141H122.991C122.78 37.2141 122.608 37.2203 122.475 37.2334C122.339 37.2442 122.236 37.285 122.158 37.3517C122.079 37.425 121.995 37.537 121.917 37.6767C121.835 37.8251 121.747 38.0146 121.636 38.2577L115.571 52.8494Z",
    fill: "#393536"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7917 35.2426V17.6165L30.5264 8.80308L45.7917 35.2426Z",
    fill: "url(#paint0_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4995 8.81799V8.78341H30.5341V8.74883H30.6033V8.71425H30.6724V8.67967H30.7416V8.64509H30.7762V8.61051H30.8453V8.57593H30.9145V8.54135H30.9836V8.50677H31.0182V8.47219H31.0874V8.43761H31.1565V8.40303H31.1911V8.36845H31.2603V8.33387H31.3294V8.29929H31.3986V8.26471H31.4332V8.23013H31.5023V8.19555H31.5715V8.16097H31.6406V8.12639H31.6752V8.09181H31.7444V8.05723H31.8135V8.02265H31.8481V7.98807H31.9173V7.95349H31.9864V7.91891H32.0556V7.88433H32.0902V7.84976H32.1593V7.81518H32.2285V7.7806H32.2977V7.74602H32.3322V7.71144H32.4014V7.67686H32.4706V7.64228H32.5397V7.6077H32.5743V7.57312H32.6435V7.53854H32.7126V7.50396H32.7472V7.46938H32.8164V7.4348H32.8855V7.40022H32.9547V7.36564H32.9893V7.33106H33.0584V7.29648H33.1276V7.2619H33.1967V7.22732H33.2313V7.19274H33.3005V7.15816H33.3696V7.12358H33.4388V7.089H33.4734V7.05442H33.5425V7.01984H33.6117V6.98526H33.6463V6.95068H33.7154V6.9161H33.7846V6.88152H33.8538V6.84694H33.8883V6.81236H33.9575V6.77778H34.0267V6.7432H34.0958V6.70862H34.1304V6.67404H34.1996V6.63946H34.2687V6.60488H34.3379V6.5703H34.3725V6.53572H34.4416V6.50114H34.5108V6.46656H34.5454V6.43198H34.6145V6.3974H34.6837V6.36282H34.7528V6.32824H34.7874V6.29366H34.8566V6.25908H34.9257V6.2245H34.9949V6.18992H35.0295V6.15534H35.0986V6.12076H35.1678V6.08618H35.2024V6.0516H35.2715V6.01702H35.3407V5.98244H35.4099V5.94786H35.4444V5.91328H35.5136V5.8787H35.5828V5.84412H35.6519V5.80954H35.6865V5.77496H35.7557V5.74038H35.8248V5.7058H35.894V5.67122H35.9286V5.63664H35.9977V5.60206H36.0669V5.56748H36.1015V5.5329H36.1706V5.49832H36.2398V5.46374H36.3089V5.42916H36.3435V5.39458H36.4127V5.36H36.4818V5.32542H36.551V5.29084H36.5856V5.25626H36.6547V5.22168H36.7239V5.1871H36.7931V5.15252H36.8276V5.11794H36.8968V5.08336H36.966V5.04878H37.0005V5.0142H37.0697V4.97962H37.1389V4.94504H37.208V4.91046H37.2426V4.87588H37.3118V4.8413H37.3809V4.80672H37.4501V4.77214H37.4847V4.73756H37.5538V4.70298H37.623V4.6684H37.6921V4.63382H37.7267V4.59924H37.7959V4.56466H37.865V4.53008H37.8996V4.4955H37.9688V4.46092H38.0379V4.42634H38.1071V4.39176H38.1417V4.35718H38.2108V4.3226H38.28V4.28802H38.3492V4.25344H38.3837V4.21886H38.4529V4.18428H38.5221V4.1497H38.5566V4.11512H38.6258V4.08054H38.695V4.04596H38.7641V4.01138H38.7987V3.9768H38.8679V3.94222H38.937V3.90764H39.0062V3.87306H39.0408V3.83848H39.1099V3.8039H39.1791V3.76932H39.2482V3.73474H39.2828V3.70016H39.352V3.66558H39.4211V3.631H39.4557V3.59642H39.5249V3.56184H39.594V3.52726H39.6632V3.49268H39.6978V3.4581H39.7669V3.42352H39.8361V3.38894H39.9053V3.35436H39.9398V3.31978H40.009V3.2852H40.0782V3.25062H40.1473V3.21604H40.1819V3.18146H40.2511V3.14688H40.3202V3.1123H40.3548V3.07772H40.424V3.04314H40.4931V3.00856H40.5623V2.97398H40.5969V2.9394H40.666V2.90482H40.7352V2.87024H40.8043V2.83566H40.8389V2.80108H40.9081V2.7665H40.9772V2.73192H41.0464V2.69734H41.081V2.66276H41.1501V2.62818H41.2193V2.5936H41.2539V2.55902H41.323V2.52444H41.3922V2.48986H41.4614V2.45529H41.4959V2.42071H41.5651V2.38613H41.6343V2.35155H41.7034V2.31697H41.738V2.28239H41.8072V2.24781H41.8763V2.21323H41.9109V2.17865H41.98V2.14407H42.0492V2.10949H42.1184V2.07491H42.1529V2.04033H42.2221V2.00575H42.2913V1.97117H42.3604V1.93659H42.395V1.90201H42.4642V1.86743H42.5333V1.83285H42.6025V1.79827H42.6371V1.76369H42.7062V1.72911H42.7754V1.69453H42.81V1.65995H42.8791V1.62537H42.9483V1.59079H43.0174V1.55621H43.052V1.52163H43.1212V1.48705H43.1903V1.45247H43.2595V1.41789H43.2941V1.38331H43.3632V1.34873H43.4324V1.31415H43.5016V1.27957H43.5361V1.24499H43.6053V1.21041H43.6745V1.17583H43.709V1.14125H43.7782V1.10667H43.8474V1.07209H43.9165V1.03751H43.9511V1.00293H44.0203V0.968348H44.0894V0.933768H44.1586V0.899188H44.1932V0.864608H44.2623V0.830028H44.3315V0.795448H44.4006V0.760868H44.4352V0.726288H44.5044V0.691708H44.5735V0.657128H44.6081V0.622549H44.6773V0.587969H44.7464V0.553389H44.8156V0.518809H44.8502V0.484229H44.9193V0.449649H44.9885V0.415069H45.0577V0.380489H45.0922V0.345909H45.1614V0.311329H45.2306V0.276749H45.2651V0.24217H45.3343V0.207589H45.4035V0.17301H45.4726V0.138429H45.5072V0.10385H45.5764V0.0692693H45.6455V0.0346899H45.7147V0.000109372H45.8876V0.0346899H45.9567V0.0692693H45.9913V0.10385H46.0605V0.138429H46.1296V0.17301H46.1642V0.207589H46.2334V0.24217H46.3025V0.276749H46.3717V0.311329H46.4063V0.345909H46.4754V0.380489H46.5446V0.415069H46.6138V0.449649H46.6483V0.484229H46.7175V0.518809H46.7867V0.553389H46.8558V0.587969H46.8904V0.622549H46.9596V0.657128H47.0287V0.691708H47.0633V0.726288H47.1325V0.760868H47.2016V0.795448H47.2708V0.830028H47.3054V0.864608H47.3745V0.899188H47.4437V0.933768H47.5128V0.968348H47.5474V1.00293H47.6166V1.03751H47.6857V1.07209H47.7549V1.10667H47.7895V1.14125H47.8586V1.17583H47.9278V1.21041H47.9624V1.24499H48.0315V1.27957H48.1007V1.31415H48.1699V1.34873H48.2044V1.38331H48.2736V1.41789H48.3428V1.45247H48.4119V1.48705H48.4465V1.52163H48.5157V1.55621H48.5848V1.59079H48.6194V1.62537H48.6886V1.65995H48.7577V1.69453H48.8269V1.72911H48.8615V1.76369H48.9306V1.79827H48.9998V1.83285H49.0689V1.86743H49.1035V1.90201H49.1727V1.93659H49.2418V1.97117H49.311V2.00575H49.3456V2.04033H49.4147V2.07491H49.4839V2.10949H49.5185V2.14407H49.5876V2.17865H49.6568V2.21323H49.726V2.24781H49.7605V2.28239H49.8297V2.31697H49.8989V2.35155H49.968V2.38613H50.0026V2.42071H50.0718V2.45529H50.1409V2.48986H50.2101V2.52444H50.2447V2.55902H50.3138V2.5936H50.383V2.62818H50.4176V2.66276H50.4867V2.69734H50.5559V2.73192H50.625V2.7665H50.6596V2.80108H50.7288V2.83566H50.7979V2.87024H50.8671V2.90482H50.9017V2.9394H50.9708V2.97398H51.04V3.00856H51.1092V3.04314H51.1437V3.07772H51.2129V3.1123H51.2821V3.14688H51.3166V3.18146H51.3858V3.21604H51.455V3.25062H51.5241V3.2852H51.5587V3.31978H51.6279V3.35436H51.697V3.38894H51.7662V3.42352H51.8008V3.4581H51.8699V3.49268H51.9391V3.52726H51.9737V3.56184H52.0428V3.59642H52.112V3.631H52.1811V3.66558H52.2157V3.70016H52.2849V3.73474H52.354V3.76932H52.4232V3.8039H52.4578V3.83848H52.5269V3.87306H52.5961V3.90764H52.6652V3.94222H52.6998V3.9768H52.769V4.01138H52.8381V4.04596H52.8727V4.08054H52.9419V4.11512H53.0111V4.1497H53.0802V4.18428H53.1148V4.21886H53.1839V4.25344H53.2531V4.28802H53.3223V4.3226H53.3568V4.35718H53.426V4.39176H53.4952V4.42634H53.5643V4.46092H53.5989V4.4955H53.6681V4.53008H53.7372V4.56466H53.7718V4.59924H53.841V4.63382H53.9101V4.6684H53.9793V4.70298H54.0139V4.73756H54.083V4.77214H54.1522V4.80672H54.2213V4.8413H54.2559V4.87588H54.3251V4.91046H54.3942V4.94504H54.4288V4.97962H54.498V5.0142H54.5671V5.04878H54.6363V5.08336H54.6709V5.11794H54.74V5.15252H54.8092V5.1871H54.8784V5.22168H54.9129V5.25626H54.9821V5.29084H55.0513V5.32542H55.1204V5.36H55.155V5.39458H55.2242V5.42916H55.2933V5.46374H55.3279V5.49832H55.3971V5.5329H55.4662V5.56748H55.5354V5.60206H55.57V5.63664H55.6391V5.67122H55.7083V5.7058H55.7774V5.74038H55.812V5.77496H55.8812V5.80954H55.9503V5.84412H56.0195V5.8787H56.0541V5.91328H56.1232V5.94786H56.1924V5.98244H56.227V6.01702H56.2961V6.0516H56.3653V6.08618H56.4345V6.12076H56.469V6.15534H56.5382V6.18992H56.6074V6.2245H56.6765V6.25908H56.7111V6.29366H56.7803V6.32824H56.8494V6.36282H56.884V6.3974H56.9532V6.43198H57.0223V6.46656H57.0915V6.50114H57.1261V6.53572H57.1952V6.5703H57.2644V6.60488H57.3335V6.63946H57.3681V6.67404H57.4373V6.70862H57.5064V6.7432H57.5756V6.77778H57.6102V6.81236H57.6793V6.84694H57.7485V6.88152H57.7831V6.9161H57.8522V6.95068H57.9214V6.98526H57.9906V7.01984H58.0251V7.05442H58.0943V7.089H58.1635V7.12358H58.2326V7.15816H58.2672V7.19274H58.3364V7.22732H58.4055V7.2619H58.4747V7.29648H58.5093V7.33106H58.5784V7.36564H58.6476V7.40022H58.6822V7.4348H58.7513V7.46938H58.8205V7.50396H58.8896V7.53854H58.9242V7.57312H58.9934V7.6077H59.0625V7.64228H59.1317V7.67686H59.1663V7.71144H59.2354V7.74602H59.3046V7.7806H59.3738V7.81518H59.4083V7.84976H59.4775V7.88433H59.5467V7.91891H59.5812V7.95349H59.6504V7.98807H59.7196V8.02265H59.7887V8.05723H59.8233V8.09181H59.8925V8.12639H59.9616V8.16097H60.0308V8.19555H60.0654V8.23013H60.1345V8.26471H60.2037V8.29929H60.2383V8.33387H60.3074V8.36845H60.3766V8.40303H60.4457V8.43761H60.4803V8.47219H60.5495V8.50677H60.6186V8.54135H60.6878V8.57593H60.7224V8.61051H60.7915V8.64509H60.8607V8.67967H60.9299V8.71425H60.9644V8.74883H61.0336V8.78341H61.0682V8.81799",
    fill: "url(#paint1_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0547 8.80549V26.4295L45.7915 35.2426L61.0547 8.80549Z",
    fill: "url(#paint2_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5264 8.80549V26.4295L45.7917 35.2426L30.5264 8.80549Z",
    fill: "url(#paint3_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7915 35.2426V17.6165L61.0547 8.80549L45.7915 35.2426Z",
    fill: "url(#paint4_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0549 8.80548L45.7917 17.6165L30.5264 8.80548H61.0549Z",
    fill: "url(#paint5_linear)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0549 61.6795L45.7917 70.4905L30.5264 61.6795H61.0549Z",
    fill: "url(#paint6_linear)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.0547 61.6795V79.3035L45.7915 88.1169L61.0547 61.6795Z",
    fill: "url(#paint7_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7915 88.1169V70.4905L61.0547 61.6795L45.7915 88.1169Z",
    fill: "url(#paint8_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5264 61.6795V79.3035L45.7917 88.1169L30.5264 61.6795Z",
    fill: "url(#paint9_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7917 88.1169V70.4905L30.5264 61.6795L45.7917 88.1169Z",
    fill: "url(#paint10_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5264 61.6796L45.7917 52.8665L61.0549 61.6796H30.5264Z",
    fill: "url(#paint11_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2627 35.2426L30.526 26.4295L45.7913 35.2426H15.2627Z",
    fill: "url(#paint12_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7917 35.2425V52.8665L30.5264 61.6796L45.7917 35.2425Z",
    fill: "url(#paint13_linear)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.526 61.6796V44.0535L15.2627 35.2425L30.526 61.6796Z",
    fill: "url(#paint14_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2627 35.2425V52.8665L30.526 61.6796L15.2627 35.2425Z",
    fill: "url(#paint15_linear)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5264 61.6796V44.0535L45.7917 35.2425L30.5264 61.6796Z",
    fill: "url(#paint16_linear)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7913 35.2426L30.526 44.0536L15.2627 35.2426H45.7913Z",
    fill: "url(#paint17_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5261 61.6795L15.2629 70.4905L0 61.6795H30.5261Z",
    fill: "url(#paint18_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.6796V44.0535L15.2629 35.2425L0 61.6796Z",
    fill: "url(#paint19_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 61.6796L15.2629 52.8665L30.5261 61.6796H0Z",
    fill: "url(#paint20_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2629 35.2425V52.8665L0 61.6796L15.2629 35.2425Z",
    fill: "url(#paint21_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.526 61.6795V79.3035L15.2627 88.1169L30.526 61.6795Z",
    fill: "url(#paint22_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7913 88.117L30.526 96.9276L15.2627 88.117H45.7913Z",
    fill: "url(#paint23_linear)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2627 88.1169L30.526 79.3035L45.7913 88.1169H15.2627Z",
    fill: "url(#paint24_linear)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2627 88.1169V70.4905L30.526 61.6795L15.2627 88.1169Z",
    fill: "url(#paint25_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 38.1588,
    y1: 43.7976,
    x2: 38.1588,
    y2: 2.55898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 30.5261,
    y1: 4.39902,
    x2: 61.0546,
    y2: 4.39902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 65.5581,
    y1: 34.1592,
    x2: 50.2602,
    y2: 18.8613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 38.2135,
    y1: 36.4193,
    x2: 37.9397,
    y2: 8.35426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 53.423,
    y1: 43.7039,
    x2: 53.423,
    y2: 13.5315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 26.5391,
    y1: 5.22404,
    x2: 78.2617,
    y2: 20.5899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 31.4219,
    y1: 58.1109,
    x2: 62.8393,
    y2: 69.498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45303,
    stopColor: "#54972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 65.5581,
    y1: 87.0332,
    x2: 50.2602,
    y2: 71.7353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 53.423,
    y1: 96.5779,
    x2: 53.423,
    y2: 66.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 23.6107,
    y1: 61.1231,
    x2: 51.4196,
    y2: 98.7952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 17.4926,
    y1: 61.0903,
    x2: 57.0984,
    y2: 86.5804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 22.7184,
    y1: 56.7457,
    x2: 62.2875,
    y2: 58.0967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45303,
    stopColor: "#54972F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8DB5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 15.2627,
    y1: 30.836,
    x2: 45.7912,
    y2: 30.836,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 50.2943,
    y1: 60.5965,
    x2: 34.9965,
    y2: 45.2987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 22.8943,
    y1: 70.2339,
    x2: 22.8943,
    y2: 28.9988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 22.8943,
    y1: 58.5971,
    x2: 22.8943,
    y2: 26.5045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 38.1588,
    y1: 70.1409,
    x2: 38.1588,
    y2: 39.9685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 10.3288,
    y1: 32.9776,
    x2: 63.5611,
    y2: 45.7369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear",
    x1: -10.0523,
    y1: 63.2387,
    x2: 42.3522,
    y2: 67.7658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear",
    x1: 7.63145,
    y1: 70.1409,
    x2: 7.63145,
    y2: 39.9685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear",
    x1: -1.86732e-7,
    y1: 57.273,
    x2: 30.5261,
    y2: 57.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEEA01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969325,
    stopColor: "#F14624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F14624"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear",
    x1: 19.7663,
    y1: 60.5962,
    x2: 4.46849,
    y2: 45.2983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear",
    x1: 22.8943,
    y1: 86.7925,
    x2: 22.8943,
    y2: 58.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear",
    x1: 10.3442,
    y1: 76.614,
    x2: 44.3446,
    y2: 96.0603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear",
    x1: 46.321,
    y1: 78.946,
    x2: 12.198,
    y2: 98.7593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008AAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CCAE1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear",
    x1: 29.5458,
    y1: 81.5498,
    x2: 11.6205,
    y2: 63.6245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C6037B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3F175D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvanialogo);
export default __webpack_public_path__ + "static/media/advanialogo.4b2440879804742280dce5b0e2540f3f.svg";
export { ForwardRef as ReactComponent };